var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"drag-contain"},on:{"mousedown":_vm.move,"touchstart":_vm.touchStart,"touchmove":function($event){$event.preventDefault();return _vm.touchMove.apply(null, arguments)},"touchend":_vm.touchEnd}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }